export class ClockIndex {
    constructor(
        public hIndex: number = 180,
        public mIndex: number = 180,
        public sIndex: number = 180
    ) {}
}
